import { Box } from '@mui/joy'
import { useIsAppControl } from '@store/isApp'
import pxToRem from '@utils/pxToRem'
import setAds from '@utils/setAds'
import { useLayoutEffect } from 'react'

const BodyImgPcAd = () => {
	const { isApp } = useIsAppControl()
	useLayoutEffect(() => {
		if (!isApp) {
			setAds({
				id: '43Y7ZQd4Tu2L2twT4rrEJg',
				inventory: 'jtbc_p/article_news/article_news@article_news_body_300x250?mlink=564',
			})
		}
	}, [isApp])
	return (
		!isApp && (
			<Box
				width={pxToRem(300)}
				display={{ xs: 'none', md: 'block' }}
				id="43Y7ZQd4Tu2L2twT4rrEJg_AD"
			/>
		)
	)
}
export default BodyImgPcAd
